// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SecurityModelIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 2q-.3 0-.56.11L3.88 5.16C3.34 5.38 3 5.9 3 6.48v4.51c0 4.99 3.85 9.6 8.6 10.96a1.4 1.4 0 0 0 .8 0c4.75-1.37 8.6-5.97 8.6-10.96V6.48c0-.58-.34-1.1-.87-1.32L12.56 2.1A1.4 1.4 0 0 0 12 2m0 1.44 7.57 3.04v4.51c0 4.32-3.47 8.4-7.57 9.58-4.1-1.18-7.56-5.26-7.56-9.58V6.48z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.94 7.8a3 3 0 0 1 3.9 3.9l7.02 7.03c.19.18.19.47 0 .65l-1.06 1.06a.46.46 0 0 1-.65 0l-5.38-5.38-1.66-1.66a3 3 0 0 1-3.86-3.9l2.22 2.22 1.7-1.7z"
      clipRule="evenodd"
    />
  </svg>,
  "SecurityModel",
);
export default SecurityModelIcon;
